export enum HostingManagement {
  FULLY_MANAGED = 'Fully Managed',
  SELF_MANAGED = 'Self-Managed',
  NOT_APPLICABLE = 'Not Applicable',
}
